module.exports = "<p (click)=\"$event.stopPropagation(); $event.preventDefault();\">\n  {{ songLength | secToMin }}\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/song-duration/song-duration.component.html
// module id = ./src/app/shared/song-duration/song-duration.component.html
// module chunks = main